import { IStairConfig, IVec3 } from '@stair-craft/common/util';

// Axis-aligned bounding box of the U-shape stair group in stair-local coords.
export function computeBoundingBox(
    config: IStairConfig,
    sw: number,
    isRight: boolean,
    geoMaxZ: number,
    exitLocalZ: number,
    totalRise: number
): { min: IVec3; max: IVec3 } {
    let minX: number = 0;
    let maxX: number = sw;
    const maxZ: number = geoMaxZ;
    const minZ: number = Math.min(0, exitLocalZ);

    if (isRight) {
        maxX = 2 * sw + config.flightGap;
    } else {
        minX = -(sw + config.flightGap);
    }

    return {
        min: { x: minX, y: 0, z: minZ },
        max: { x: maxX, y: totalRise, z: maxZ },
    };
}
